import { Routes } from '@angular/router';
import { authMatchGuard } from '../auth/guards/auth.guard';
import { accommodationRoutes } from '@at/trip/accommodations';
import { activitiesRoutes } from '@at/trip/activities';
import { budgetRoutes } from '@at/trip/budgets';
import { datesRoutes } from '@at/trip/dates';
import { flightsRoutes } from '@at/trip/flights';
import { invitesRoutes } from '@at/trip/invites';
import { locationsRoutes } from '@at/trip/locations';
import { peopleRoutes } from '@at/trip/people';
import { itineraryRoutes } from './modules/itinerary/itinerary.routes';

export const tripRoutes: Routes = [
  {
    path: 'trip',
    redirectTo: 'trip/create',
    pathMatch: 'full',
  },
  {
    path: 'trips',
    title: `trips`,
    children: [
      {
        path: 'invite/join',
        children: [...invitesRoutes.join],
      },
    ],
  },
  {
    path: 'trip',
    title: `trip`,
    children: [
      {
        path: 'create',
        loadComponent: () =>
          import('./pages/create/create.component').then((m) => m.CreateTripComponent),
        canMatch: [authMatchGuard],
        children: [
          {
            path: 'name',
            loadComponent: () =>
              import('./pages/create/name/name.component').then((m) => m.CreateTripNameComponent),
          },
          ...locationsRoutes.create,
          ...datesRoutes.create,
          {
            path: 'summary',
            loadComponent: () =>
              import('./pages/create/summary/summary.component').then(
                (m) => m.CreateTripSummaryComponent,
              ),
          },
          {
            path: '',
            redirectTo: 'name',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/view/trip.component').then((m) => m.TripComponent),
        canMatch: [authMatchGuard],
        children: [
          {
            path: '',
            title: `trip summary`,
            loadComponent: () =>
              import('./pages/view/summary/summary.component').then((m) => m.SummaryComponent),
          },
          ...peopleRoutes.view,
          ...datesRoutes.view,
          ...budgetRoutes.view,
          ...locationsRoutes.view,
          ...itineraryRoutes.view,
          ...accommodationRoutes.view,
          ...flightsRoutes.view,
          ...activitiesRoutes.view,
          {
            path: '',
            redirectTo: 'summary',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
];
